import { spawn, call } from 'redux-saga/effects';
import createFlowsSaga from './flows';

export default function* rootSaga() {
  const flowsSaga = yield call(createFlowsSaga);
  yield spawn(flowsSaga);
}
